import { Input, KeyCode } from "../../lib/Input";
import MonoBehavior from "../../lib/MonoBehavior";
import { Time } from "../../lib/Time";
import Vector2 from "../../math/Vector2";
import SPAbility from "../SPAbility";
import SPPlayer from "../SPPlayer";

export default class SPDash extends SPAbility {
    invuln = false;

    constructor(player: SPPlayer) {
        super(player, {
            cooldown: 3,
            duration: 1,
            icon: 9,
            trigger: KeyCode.Space,
            triggerType: Input.GetKeyDown
        });
    }

    onDurationEnd(): void {
        this.player.friction = 0.5;
    }

    onUse(): void {
        const vec = this.player.engine.mouseWorldPosition.sub(this.player.transform.position).normalized;
        this.player.velocity = vec.scale(this.player.accelerationForce * 3);
        this.player.friction = 2;

        if (this.invuln) this.player.SetInvuln(1);
    }

}

// export default class SPDash extends MonoBehavior {

//     cooldown = 3;
//     cooldownTimer = 0;
//     invuln = false;

//     Update(): void {

//         if (this.cooldownTimer > 0) {
//             this.cooldownTimer -= Time.deltaTime;

//             if (this.cooldownTimer <= 0) this.cooldownTimer = 0;
//             return;
//         }

//         if (Input.GetKeyDown(KeyCode.Space)) {
//             this.cooldownTimer = this.cooldown;
//             const vec = this.engine.mouseWorldPosition.sub(SPPlayer.Singleton.transform.position).normalized;

//             SPPlayer.Singleton.velocity = vec.scale(SPPlayer.Singleton.accelerationForce * 3);
//             SPPlayer.Singleton.friction = 2;

//             if (this.invuln) SPPlayer.Singleton.SetInvuln(1);

//             setTimeout(() => {
//                 SPPlayer.Singleton.friction = 0.5;
//             }, 1000);
//         }
//     }

//     Draw(): void {
//         this.ctx.fillStyle = '#55ff5555';
//         this.engine.FillRect(SPPlayer.Singleton.transform.position.add(new Vector2(-25, SPPlayer.Singleton.size + 12)), new Vector2(50, 2));
//         this.ctx.fillStyle = '#55ff55';
//         this.engine.FillRect(SPPlayer.Singleton.transform.position.add(new Vector2(-25, SPPlayer.Singleton.size + 12)), new Vector2(50 * (this.cooldownTimer / this.cooldown), 2));
//     }

// }